
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Button, Input } from 'ant-design-vue';
import BaseTabs from './common/BaseTabs.vue';

const user = namespace('user');

@Component({
  components: {
    AButton: Button,
    BaseTabs,
    AInputSearch: Input.Search,
  },
})
export default class ClassCheck extends Vue {
  @user.State('userInfo') userInfo: any;

  private tabs: any[] = [];

  private list: any[] = [];

  // 选中的文本内容
  private searchText: any = ''

  // 是否触发搜索路由页面
  private currentSearchStatus: boolean = false;

  // 搜索历史记录
  private searchHistoryArr: string[] = []

  // 显示搜索记录状态
  private searchHistoryStatus: boolean = false

  // 记录搜索记录失去焦点的逻辑处理
  private searchHistoryTimer: any = null

  private currentPathName: any = ''

  private activeIndex: number = 1;

  get isManage(): boolean {
    const { roles } = this.userInfo;
    return (
      roles.indexOf('manage') !== -1 || roles.indexOf('super_manager') !== -1
    );
  }

  get isTeacher(): boolean {
    const { roles } = this.userInfo;
    return roles.indexOf('teacher') !== -1;
  }

  @Watch('$route')
  handleRouter() {
    const { name } = this.$route;
    if (name === 'Index') {
      this.activeIndex = 2;
      this.currentSearchStatus = false;
      this.searchText = '';
    } else if (name === 'History') {
      this.activeIndex = 1;
      this.currentSearchStatus = false;
      this.searchText = '';
    } else if (name === 'Search') {
      this.currentSearchStatus = true;
      this.searchText = this.$route.query.value;
    } else if (name === 'LessonData') {
      this.activeIndex = 3;
      this.currentSearchStatus = false;
      this.searchText = '';
    }
  }

  @Watch('userInfo')
  handleUserInfo(newVal: any) {
    if (newVal) {
      this.allCourseShow();
    }
  }

  private updateSubject(id: number) {
    const HistoryRouteName = 'History';
    const IndexRouteName = 'Index';
    this.activeIndex = id;
    if (id === 1 && this.$route.name !== HistoryRouteName) {
      this.$utils.sendAction('index', 'history', 'id-11'); // 我的班级
      this.$router.push('/history');
    } else if (id === 2 && this.$route.name !== IndexRouteName) {
      this.$utils.sendAction('index', 'history', 'id-12'); // 全部课程
      this.$router.push('/index');
    } else if (id === 3) {
      this.$utils.sendAction('index', 'history', 'id-13'); // 课堂数据
      this.$router.push('/lessonData');
    }
  }

  private onFocus() {
    this.searchHistoryStatus = true;
  }

  private onBlur() {
    this.searchHistoryTimer = setTimeout(() => {
      this.searchHistoryStatus = false;
    }, 200);
  }

  // 记录框获取hover态
  private handleWrapMouseOver() {
    if (this.searchHistoryTimer) {
      clearTimeout(this.searchHistoryTimer);
      this.searchHistoryTimer = null;
    }
  }

  // 清空搜索记录
  private handleClearHistory() {
    let searchHistroyList = this.$utils.getStore('searchHistroyList');
    if (searchHistroyList && searchHistroyList.length > 0) {
      searchHistroyList = [];
    }
    this.$utils.setStore('searchHistroyList', searchHistroyList);
    this.searchHistoryArr = [];
  }

  // 选择历史记录内容
  private handleSelectedText(item: {text: string; id: number}) {
    this.searchText = item.text;
    this.searchHistoryStatus = false;
    this.onSearch(item.text);
  }

  // 删除单条历史记录
  private handleDeleteText(item: {text: string; id: number}) {
    const searchHistroyList = this.$utils.getStore('searchHistroyList')
      .filter((list: {text: string; id: number}) => list.id !== item.id);
    this.$utils.setStore('searchHistroyList', searchHistroyList);
    this.searchHistoryArr = searchHistroyList.reverse();
  }

  // hover 单条记录
  private handlemouseOver(item: any) {
    this.searchHistoryArr.forEach((list: any) => {
      if (list.id === item.id) {
        list.showClear = true;
      }
    });
  }

  // 鼠标离开
  private handlemouseLeave(item: any) {
    this.searchHistoryArr.forEach((list: any) => {
      if (list.id === item.id) {
        list.showClear = false;
      }
    });
  }

  // 搜索输入框变化
  onChange(e: any) {
    if (e.target.value.trim().length === 30) {
      this.$toast.show('最多输入30个字符');
    }
  }

  // 搜索课程
  private onSearch(value: string) {
    if (value.trim().length === 0) return;
    if (this.$route.name !== 'Search') {
      this.currentPathName = this.$route.name;
    }
    // 设置搜索记录
    let searchHistroyList = this.$utils.getStore('searchHistroyList');
    let tempId;
    if (searchHistroyList && searchHistroyList.length > 0) {
      tempId = searchHistroyList[searchHistroyList.length - 1].id;
      const tempItem = searchHistroyList.find((item: any) => item.text === value.trim());
      if (tempItem && tempItem.id) {
        searchHistroyList = searchHistroyList.filter((item: any) => item.id !== tempItem.id);
      }
      if (searchHistroyList.length === 10) {
        searchHistroyList.shift();
      }
      searchHistroyList.push({
        text: value.trim(),
        showClear: false,
        id: tempId + 1,
      });
    } else {
      tempId = 1;
      searchHistroyList = [{ text: value.trim(), showClear: false, id: 1 }];
    }
    this.$utils.setStore('searchHistroyList', searchHistroyList);
    this.searchHistoryArr = searchHistroyList.reverse();
    const options = {
      backPath: this.currentPathName,
      value: value.trim(),
      id: tempId,
      searchPage: 'true',
    };
    //  埋点搜索内容记录
    this.$utils.sendAction('index', 'index', 'id-17', options); // 全部课程
    this.$router.push({
      path: '/search',
      query: options,
    }).catch();
  }

  private getclassAndclassType() {
    let classNum: number = 0;
    let classTypeNum: number = 0;
    this.$service.bk.getMyClassAndType({
      subjectId: 0,
      gradeId: 0,
      createdClass: 0,
      typesId: 0,
      period: 0,
    }).then((res: any) => {
      res.list.forEach((item: any) => {
        if (item.type === 1) {
          classNum += 1;
        } else if (item.type === 2) {
          classTypeNum += 1;
        }
      });
      if (classNum > 0) {
        this.tabs.push({ id: 1, name: '我的班级' });
      }
      if (classTypeNum > 0) {
        this.tabs.push({ id: 2, name: '全部课程111' });
      }
    });
  }

  private allCourseShow() {
    const { pageAccess, institutionId } = this.userInfo;
    if (this.userInfo.classNumInfo && this.userInfo.classNumInfo.classNum) {
      this.tabs.push({ id: 1, name: '我的班级' });
    }
    if (this.isManage || this.isTeacher) {
      // 新签约个体 有教师但到期、或者没有教师角色的
      if ((pageAccess.signType === 2 && pageAccess.status === 2) || (pageAccess.signType === 2 && !this.isTeacher)) {
        return;
      }
      this.tabs.push({ id: 2, name: '全部课程' });
    }
    if (institutionId === 24) {
      this.tabs.push({ id: 3, name: '课堂数据' });
    }
  }

  private created() {
    const searchHistroyList = this.$utils.getStore('searchHistroyList');
    if (searchHistroyList && searchHistroyList.length > 0) {
      this.searchHistoryArr = searchHistroyList.reverse();
    }
  }
}
